import { useCallback } from 'react';
import { useParams } from 'react-router';

import type { TestRunsActionsProps } from '~/components/TestRunsActions/TestRunsActions';

import { TestRunsActions } from '~/components/TestRunsActions/TestRunsActions';
import { useAppDispatch } from '~/modules/store';
import { SuiteRunActions } from '~/modules/suiteRun/suiteRun.redux';

export const TestRunsWithinSuiteActions = ({ row }: Omit<TestRunsActionsProps, 'onDelete'>) => {
  const { suiteRunId } = useParams<{
    suiteRunId: string;
  }>();
  const dispatch = useAppDispatch();
  const testRun = row.original;

  const onDelete = useCallback(() => {
    dispatch(SuiteRunActions.removeTestRuns(suiteRunId, testRun.id));
  }, [dispatch, suiteRunId, testRun.id]);

  return <TestRunsActions row={row} onDelete={onDelete} />;
};
